import { render } from "./QuotationViewFullKit.vue?vue&type=template&id=162064b1"
import script from "./QuotationViewFullKit.vue?vue&type=script&lang=js"
export * from "./QuotationViewFullKit.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__